import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import debounce from 'lodash.debounce';

import { BaseInput } from '../FormStyles/Input';

const SearchWrapper = styled.div`
  border: 0.5px solid ${themeGet('colors.black.40')};
  border-radius: 8px;
  display: flex;
  align-items: center;
  max-width: ${props => props.maxWidth};
  width: 100%;
  &:focus-within {
    outline: ${themeGet('colors.primary.100')} auto 1px;
  }
`;

const SearchInput = styled(BaseInput)`
  border: 0 !important;
  padding: 9px 9px 9px 6px !important;
  width: 100%;
  color: ${themeGet('colors.black.100')} !important;
  font-size: ${props => props.fontSize} !important;
  font-weight: 400 !important;
  line-height: 14px !important;
  ::placeholder {
    color: ${themeGet('colors.black.60')};
  }
  &:focus {
    outline: none;
  }
`;

const Icon = styled.i`
  margin: 0 10px;
  ${variant({
    variants: {
      search: {
        height: '10px',
        width: '10px',
        marginTop: '11px',
      },
    },
  })}
`;

const CloseIcon = styled(Icon)`
  cursor: pointer;
`;

CloseIcon.defaultProps = {
  className: 'fa-light fa-xmark'
};

const Search = ({
  executeSearch,
  excludeCloseIcon = false,
  searchInitialValue,
  clearSearch,
  placeholder,
  onKeyDown,
  inputId,
  fontSize = '11px',
  width = '100%',
  imgWidth = '10px',
  imgHeight = '10px',
  variant,
}) => {
  const [searchValue, setSearchValue] = useState(searchInitialValue || '');

  const debouncedSearch = useCallback(
    debounce(value => {
      executeSearch(value);
    }, 500),
    [],
  );

  return (
    <SearchWrapper maxWidth={width}>
      <Icon
        className='fa-regular fa-search fa-lg'
        width={imgWidth}
        height={imgHeight}
        variant={variant}
      />
      <SearchInput
        id={inputId}
        value={searchValue}
        onChange={e => {
          setSearchValue(e.target.value);
          debouncedSearch(e.target.value);
        }}
        type='search'
        placeholder={placeholder}
        fontSize={fontSize}
        onKeyDown={onKeyDown}
      />
      {searchValue && !excludeCloseIcon && (
        <CloseIcon
          width='15'
          height='15'
          onClick={() => {
            clearSearch();
            setSearchValue('');
          }}
        />
      )}
    </SearchWrapper>
  );
};

export default Search;
